import React from "react";
import { Select } from "antd";

export default class BeneficiaryRelationshipSelector extends React.Component {
  render() {

    const relations = this.props.relations;
    return (
      <Select
        {...this.props}
        size={this.props.size}
        style={{ width: "200", fontSize: 16 }}
        defaultValue={this.props.defaultValue}
        onChange={this.props.onChange}
      >
        {relations.map((relationship, idx) => {
          return (
              <Select.Option value={relationship.code} key={relationship.code}>
                {relationship.value}
              </Select.Option>
          );
        })}
      </Select>
    );
  }
}
